"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stateMap_1 = require("./stateMap");
var countryMap_1 = require("./countryMap");
/**
 * getDisplayLocation
 * returns the location string to display based on a city, state and country
 * non-US countries will not display state information
 * US will not display country unless there is no city and no state
 * @param city
 * @param state
 * @param country
 */
exports.getDisplayLocationString = function (city, state, country) {
    var isUS = country === 'US' || country === 'USA';
    var stateStr = isUS ? "" + (stateMap_1.stateMap[state] || state) : '';
    var countryStr = (isUS && (city || state)) ? '' : countryMap_1.iso2Toiso3Map[country] || country;
    return [city, stateStr, countryStr].filter(function (s) { return s; }).join(', ');
};
//# sourceMappingURL=region.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/region/region.js
 ** module id = 2089
 ** module chunks = 0
 **/